import React from "react";
import { Card, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { COLORS, FilterState } from "../../types/profession.types";

interface FilterBarProps {
  filters: FilterState;
  onFilterChange: (key: keyof FilterState, value: string) => void;
  onReset: () => void;
  showFilters: boolean;
  onToggleFilters: () => void;
  totalCount: number;
  filteredCount: number;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  filters,
  onFilterChange,
  onReset,
  showFilters,
  onToggleFilters,
  totalCount,
  filteredCount,
}) => {
  return (
    <Card className="mb-4" style={{ border: `1px solid ${COLORS.border}`, borderRadius: "8px" }}>
      <Card.Body className="p-3">
        <Row className="g-3">
          <Col xs={12} md={8}>
            <div className="position-relative">
              <InputGroup>
                <InputGroup.Text style={{ backgroundColor: COLORS.light, borderColor: COLORS.border }}>
                  🔍
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Rechercher une profession..."
                  value={filters.searchText}
                  onChange={(e) => onFilterChange("searchText", e.target.value)}
                  style={{ borderColor: COLORS.border, fontSize: "16px", height: "44px" }}
                />
                {filters.searchText && (
                  <Button
                    variant="link"
                    onClick={() => onFilterChange("searchText", "")}
                    className="position-absolute end-0 top-50 translate-middle-y"
                    style={{ color: COLORS.textLight, zIndex: 10, textDecoration: 'none' }}
                  >
                    ✕
                  </Button>
                )}
              </InputGroup>
            </div>
          </Col>
          
          <Col xs={12} md={4}>
            <Button
              variant="outline-secondary"
              onClick={onToggleFilters}
              style={{ borderColor: COLORS.border, color: COLORS.text, width: "100%", height: "44px" }}
            >
              <span style={{ marginRight: '4px' }}>⚙️</span>
              {showFilters ? "Masquer les filtres" : "Afficher les filtres"}
            </Button>
          </Col>
        </Row>

        {showFilters && (
          <>
            <hr className="my-3" />
            <Row className="g-3">
              <Col xs={12} sm={6} md={3}>
                <Form.Label className="small text-muted mb-1">Prioritaire</Form.Label>
                <Form.Select
                  value={filters.priorityFilter}
                  onChange={(e) => onFilterChange("priorityFilter", e.target.value)}
                  style={{ height: "38px" }}
                >
                  <option value="all">Tous</option>
                  <option value="priority">Prioritaires</option>
                  <option value="non-priority">Non prioritaires</option>
                </Form.Select>
              </Col>
              
              <Col xs={12} sm={6} md={3}>
                <Form.Label className="small text-muted mb-1">Utilisateurs</Form.Label>
                <Form.Select
                  value={filters.userFilter}
                  onChange={(e) => onFilterChange("userFilter", e.target.value)}
                  style={{ height: "38px" }}
                >
                  <option value="all">Tous</option>
                  <option value="zero">Aucun utilisateur</option>
                  <option value="few">Moins de 5</option>
                  <option value="many">5 et plus</option>
                </Form.Select>
              </Col>
              
              <Col xs={12} sm={6} md={3}>
                <Form.Label className="small text-muted mb-1">Prix Premium</Form.Label>
                <Form.Select
                  value={filters.premiumPriceFilter}
                  onChange={(e) => onFilterChange("premiumPriceFilter", e.target.value)}
                  style={{ height: "38px" }}
                >
                  <option value="all">Tous</option>
                  <option value="free">Gratuit</option>
                  <option value="low">&lt; 200€</option>
                  <option value="medium">200€ - 400€</option>
                  <option value="high">400€ et +</option>
                </Form.Select>
              </Col>
              
              <Col xs={12} sm={6} md={3}>
                <Form.Label className="small text-muted mb-1">Prix Export</Form.Label>
                <Form.Select
                  value={filters.exportPriceFilter}
                  onChange={(e) => onFilterChange("exportPriceFilter", e.target.value)}
                  style={{ height: "38px" }}
                >
                  <option value="all">Tous</option>
                  <option value="free">Gratuit</option>
                  <option value="paid">Payant</option>
                </Form.Select>
              </Col>
            </Row>
            
            <Row className="mt-3">
              <Col className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
                <div className="small text-muted">
                  <span style={{ marginRight: '4px' }}>📊</span>
                  {filteredCount} profession(s) sur {totalCount}
                </div>
                <Button
                  variant="link"
                  onClick={onReset}
                  size="sm"
                  style={{ color: COLORS.primary, textDecoration: "none" }}
                >
                  Réinitialiser les filtres
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
};